import { useState, useEffect } from 'react';
import { listsService, List, CreateListData, UpdateListData } from '../services/firebaseFunctions';

export const useLists = () => {
  const [lists, setLists] = useState<List[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Carregar listas
  const loadLists = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await listsService.getAll();
      setLists(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar listas');
    } finally {
      setLoading(false);
    }
  };

  // Criar lista
  const createList = async (data: CreateListData) => {
    try {
      const result = await listsService.create(data);
      if (result.success && result.data) {
        setLists((prev) => [...prev, result.data!]);
        return { success: true, response: result };
      } else {
        return { success: false, response: result };
      }
    } catch (err) {
      return { success: false, response: undefined };
    }
  };

  // Atualizar lista
  const updateList = async (id: string, data: UpdateListData) => {
    try {
      const result = await listsService.update(id, data);
      if (result.success) {
        setLists((prev) => prev.map((list) => {
          if (list.id !== id) return list;
          const { description, ...listFields } = data;
          const next: List = { ...list, ...listFields };
          if (description === null) delete next.description;
          else if (description !== undefined) next.description = description;
          return next;
        }));
        return { success: true, response: result };
      } else {
        return { success: false, response: result };
      }
    } catch (err) {
      return { success: false, response: undefined };
    }
  };

  // Deletar lista
  const deleteList = async (id: string) => {
    try {
      const result = await listsService.delete(id);
      if (result.success) {
        setLists((prev) => prev.filter((list) => list.id !== id));
        return { success: true, response: result };
      } else {
        return { success: false, response: result };
      }
    } catch (err) {
      return { success: false, response: undefined };
    }
  };

  // Carregar listas na inicialização
  useEffect(() => {
    loadLists();
  }, []);

  return {
    lists,
    loading,
    error,
    createList,
    updateList,
    deleteList,
    loadLists,
  };
};
